module.exports = __webpack_public_path__ + "jouni-nieminen_square-d6b642935cdbb5b58e869a6ad3ed9c1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/fi/jouni-nieminen_square.jpg
// module id = 1174
// module chunks = 1 2